import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import _ from 'lodash';

import AccountNumberAutoSuggests from '../common/accountNumberAutoSuggests';

/* Dialogs */
import SelectProductsToReturnOverlayDialog from '../../dialogs/selectProductsToReturnOverlayDialog';
import ReturnPolicyGuidelinesOverlayDialog from '../../dialogs/returnPolicyGuidelinesOverlayDialog';
import RequestReturnFileWarningDialog from '../../dialogs/requestReturnFileWarningDialog';

import { routes } from '../../../redux/api/routes';
const {
	orders,
	bootAPIUrl,
} = routes;
import {
	sendRequest
} from '../../../redux/api/sendRequest';

/* Actions */
import {
	getOrderList,
	saveRequestReturnList,
	setRequestReturnDetails,
	saveSerialData,
	getOrderDetails,
	updateRequestReturnParams,
	ajaxRequestInitiated,
	ajaxRequestCompleted,
	savePreviousReturnAndCreditDetails,
	saveRequestReturnPimData,
} from '../../../redux/actions';

class RequestReturn extends Component {

	constructor(props) {
		super(props);
		this.state = {
			showSelectProductsToReturnOverlayDialog: false,
			showReturnPolicyGuidelinesOverlayDialog: false,
			olderThanInvoiceAgeMessage: 'This request is older than allowed by the Return and Scrap Policy.',
			olderThanYearMessage:'As-Is invoices are not eligible for credit beyond 1 year.',
			olderThanTwoYearMessage:'Invoices are not eligible for credit beyond 2 years.',
			resultFilterBy: '',
			resultFilterByValue: '',

			accountNumber: '',
			errorMessage: '',

			filterConfirmationMessage: '',

			sortBy: 'orderDate,desc',
			filterListOfOrders: {
				param: {
					filterBy: 'serialNumber',
					filterString: ''
				},
				error: {
					filterByError: '',
					filterStringError: '',
					modelNumberError: '',
					serialNumberError: ''
				}
			},
			requestReturnList: null,
			isSerialNumberSearch: false,
			showRequestReturnFileWarningDialog:false,
			showSerialErrorMessage : false
		}
		// this.hideFilterResultMessage = this.hideFilterResultMessage.bind(this);
		this.getOrderList = this.getOrderList.bind(this);
		this.processAndFilterResponse = this.processAndFilterResponse.bind(this);
	}

	componentWillMount() {
		window.scrollTo(0, 0);
		const self = this;
		if(!self.props.hasRequestReturnAccess) {
			browserHistory.push('/home');
		} else {
			const { history } = self.props;
			if(history.length > 0 && history[history.length - 1].pathname !== '/requestreturnstep1' && history[history.length - 1].pathname !== '/previousreturnandcredit' && history[history.length - 1].pathname !=='/requestreturnstep2') {
				self.props.setRequestReturnDetails(null);
				self.props.saveRequestReturnList(null);
				self.props.updateRequestReturnParams(null);
			} else {
				const { requestReturnList, requestReturnFilterListOfOrders } = self.props.state.order;
				if(requestReturnList && requestReturnFilterListOfOrders) {
					self.setState({
						filterListOfOrders: requestReturnFilterListOfOrders,
						requestReturnList,
						resultFilterBy: requestReturnFilterListOfOrders.param.filterBy,
						resultFilterByValue: requestReturnFilterListOfOrders.param.filterString,
					});
					self.props.setRequestReturnDetails(null);
					self.props.saveRequestReturnList(null);
				}
			}
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		var self = this,
			accountNumber = self.props.getSelectedAccountNumber();
		if(accountNumber) {
			self.setState({
				accountNumber: accountNumber
			});
		} else {
			browserHistory.push('/manageorders');
		}
	}

	getDataByFilterOptions(orderHeader) {
		const self = this;
		let data = null;
		const { filterListOfOrders } = self.state;
		const resultFilterBy = filterListOfOrders.param.filterBy,
			resultFilterByValue = filterListOfOrders.param.filterString;
		if (resultFilterBy === 'invoiceNumber') {
			// Take the same invoiceNumber which user has entered
			data = orderHeader.invoices.invoice.find(itm => itm.invoiceNumber === resultFilterByValue);
		} else {
			// Take the latest invoice number from array
			data = _.maxBy(orderHeader.invoices.invoice, 'invoiceNumber');
		}
		return data;
	}

	processInvoiceNumberDate(orderHeader) {
		const self = this;
		let invoiceNumber = orderHeader.invoiceNumber;
		let invoiceDate = orderHeader.invoiceDate;
		let data = self.getDataByFilterOptions(orderHeader);
		if(data) {
			invoiceNumber = data.invoiceNumber;
			invoiceDate = data.invoiceDate;
		}

		return {
			invoiceNumber,
			invoiceDate
		};
	}

	getOrderList(queryString, callback) {
		const self = this;
		self.setState({
			requestReturnList: null,
			errorMessage: '',
			filterConfirmationMessage: '',
		}, () => {
			self.props.getOrderList(queryString, (response) => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					});
				} else {
					if(self.state.isSerialNumberSearch) {
						response.responseObject = response.responseObject ;
						// Filter SHIP_OR_RETURN === "Ship" for all users
						self.props.saveSerialData(response.responseObject);
						response.responseObject = response.responseObject.filter(item => item.line_TYPE === "Standard Line" && item.account_NUMBER === self.props.getSelectedAccountNumber());
						if (response.responseObject.length === 0 && self.state.isNextServiceCallRequired) {
							self.setState({
								isNextServiceCallRequired: false,
							}, () => {
								self.getOrderList(self.state.queryStringBkp, callback);
							});
						} else {
							const promises = [];
							self.props.ajaxRequestInitiated();
							response.responseObject.forEach(item => {
								promises.push(
									sendRequest(
										bootAPIUrl,
										orders.getOrderListBoot.path,
										'',
										orders.getOrderListBoot.method,
										`accountNumber=${self.state.accountNumber}&orderNumber=${item.order_NUMBER}`
									)
								);
							});
							Promise.all(promises).then((responses) => {
								// logic to combine all responses and then run call back
								let responseObject = [];
								let response = {};
								if(responses.length > 0) {
									responses.forEach(resp => {
										responseObject = responseObject.concat(resp.responseObject);
									});
									response = {
										...responses[0],
										responseObject
									}
								} else {
									response.responseObject = [];
								}
								self.props.ajaxRequestCompleted();
								self.processAndFilterResponse(response, callback);
							});
						}
					} else {
						self.processAndFilterResponse(response, callback);
					}
				}
			});
		});
	}

	processAndFilterResponse(response, callback) {
		const self = this;
		const { typeOfUser } = self.props.state.user.userDetails;
		let finalObject = [];
		response.responseObject = response.responseObject || [];

		// Excluded CANCELLED orders
		// Excluded FedEx
		// atlease one line should standard line or bill only line
		// exclude GEA Parts agreement type orders
		response.responseObject = response.responseObject.filter(item =>
			item && item.orderHeader &&
			item.orderHeader.orderStatus !== 'CANCELLED' && 
			item.orderHeader.shipmentMethod.description.indexOf('FedEx') === -1 &&
			item.orderDetail.orderLine.find(itm => itm.lineType === "Standard Line" || itm.lineType === "Bill Only Line") &&
			self.props.getAttributeBySalesAgreement(item.orderHeader.salesAgreement.agreementNumber, 'AGREEMENT_TYPE') !== 'GEA Parts'
		);
		let filterConfirmationMessage = (response.responseObject.length === 0 ? 'No orders found meeting the specified criteria; please try your search again.' : '');
		if(response.responseObject.length > 0) {
			// Check if all records are of ENTERED Status or not
			const notEnteredOrders = _.filter(response.responseObject, item => {
				return item.orderHeader.orderStatus !== 'ENTERED';
			});

			finalObject = notEnteredOrders;

			if(notEnteredOrders.length === 0) {
				finalObject = [];
				filterConfirmationMessage = "Order is in Entered status and not eligible for return.";
			} else {
				finalObject = [];
				notEnteredOrders.forEach(item => {
					// This will filter out records which are older than 90 days
					if(typeOfUser === 'customer') {
						if(!item.orderHeader.invoiceDate || !moment(item.orderHeader.invoiceDate).isBefore(moment().subtract(90, 'day'))) {
							finalObject.push(item);
						}
					} else {
						finalObject.push(item);
					}
				});
				if(finalObject.length === 0) {
					filterConfirmationMessage = 'Order is not eligible for return.';
				}
			}
		}
		self.setState({
			filterConfirmationMessage,
		}, () => {
			const sortBy = self.state.sortBy.split(',')[0],
				sortOrder = self.state.sortBy.split(',')[1];
			response.responseObject = _.orderBy(finalObject, (e) => { return e.orderHeader[sortBy]}, [sortOrder]);
			callback && callback(response);
		});
	}

	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	handleFilterListOfOrders(event) {
		event.preventDefault();
		const self = this;
		let { filterListOfOrders, inValid } = this.state;
		let anyError = false;
		if (
			(filterListOfOrders.param.filterBy === 'orderNumber' && !self.props.isValidOrderNumer(filterListOfOrders.param.filterString)) ||
			(filterListOfOrders.param.filterBy === 'referenceNumber' && !self.props.isValidReferenceNumber(filterListOfOrders.param.filterString))
		) {
			anyError = true;
		}
		if(inValid) {
			filterListOfOrders.param.modelNumber = ''
		}
		if(
			!anyError && filterListOfOrders.param.filterBy !== '' &&
				(
					(filterListOfOrders.param.filterBy !== 'serialNumber' && filterListOfOrders.param.filterString !== '') ||
					(filterListOfOrders.param.filterBy === 'serialNumber' && filterListOfOrders.param.serialNumber !== '')
				)
		) {
			let queryStringParams = '';
			if(filterListOfOrders.param.filterBy !== '') {
				if(filterListOfOrders.param.filterBy !== 'serialNumber' && filterListOfOrders.param.filterString !== '') {
					let filterString = filterListOfOrders.param.filterString;
					if(filterListOfOrders.param.filterBy === 'poNumber') {
						filterString = encodeURIComponent(filterString);
					}
					queryStringParams += `&${filterListOfOrders.param.filterBy}=${filterString}`;
				} else {
					if(filterListOfOrders.param.modelNumber) {
						queryStringParams += `&modelNumber=${filterListOfOrders.param.modelNumber.trim()}`;
					}
					if(filterListOfOrders.param.serialNumber) {
						const pattern = /^[A-Z]{2}\d{6}$/;
						if(!pattern.test(filterListOfOrders.param.serialNumber.trim().toUpperCase())){
							self.setState({
								showSerialErrorMessage : true,
								showRequestReturnFileWarningDialog : true
							});
							return
						}else{
							queryStringParams += `&serialNumber=${filterListOfOrders.param.serialNumber.trim()}`;
						}
					}
				}
			}
			let isNextServiceCallRequired = false;
			if (filterListOfOrders.param.filterBy === 'serialNumber' && filterListOfOrders.param.serialNumber !== '') {
				//const searchStr = filterListOfOrders.param.serialNumber.toLowerCase();
				//if(searchStr.indexOf('-ad1') === -1 || searchStr.indexOf('-ad1') !== searchStr.length - 4) {
					//isNextServiceCallRequired = true;
				//}
			}
			self.setState({
				isSerialNumberSearch: filterListOfOrders.param.filterBy === 'serialNumber' && filterListOfOrders.param.serialNumber !== '',
				isNextServiceCallRequired,
				queryStringBkp: isNextServiceCallRequired ? `requestType=requestReturn&accountNumber=${self.state.accountNumber}${queryStringParams}-AD1` : '',
			}, () => {
				self.getOrderList(`requestType=requestReturn&accountNumber=${self.state.accountNumber}${queryStringParams}`, (response) => {
					self.setState({
						requestReturnList: response,
						resultFilterBy: filterListOfOrders.param.filterBy,
						resultFilterByValue: filterListOfOrders.param.filterString
					});
				});
			});

		} else {
			let error = this.state.filterListOfOrders.error;
			if(filterListOfOrders.param.filterBy === '') {
				error.filterByError = 'error'
			} else {
				if (anyError) {
					error.filterStringError = 'error'
				} else {
					if(filterListOfOrders.param.filterBy === 'serialNumber') {
						error = {
							...error,
							filterStringError: '',
							serialNumberError: filterListOfOrders.param.serialNumber === '' ? 'error' : '',
							modelNumberError: '',
						}
					} else {
						error = {
							...error,
							filterStringError: filterListOfOrders.param.filterString === '' ? 'error' : '',
							serialNumberError: '',
							modelNumberError: '',
						}
					}
				}
			}
			this.setState({
				filterListOfOrders: {
					...this.state.filterListOfOrders,
					error: error
				},
				filterConfirmationMessage: ''
			})
		}
	}

	fetchOrderDetails(response) {
		const self = this;
		const orderNumbers = [];
		response.responseObject.forEach(itm => {
			if(itm.orderHeader.orderNumber) {
				orderNumbers.push(itm.orderHeader.orderNumber);
			}
		});
		self.props.getOrderDetailsInParallelBatches(orderNumbers);
	}

	componentWillUnmount() {
		this.props.updateRequestReturnParams(this.state.filterListOfOrders);
	}

	updateParams(formName, event) {
		//Reseting Errors on change
		let error = this.state[formName].error;
		let param = this.state[formName].param;
		for (var key in error) {
			if (error.hasOwnProperty(key)) {
				error[key] = '';
			}
		}
		param = {
			...param,
			filterString: event.target.name === 'filterBy'?'':this.state[formName].param.filterString,
			[event.target.name]: event.target.value
		};
		if(formName === 'filterListOfOrders') {
			if(event.target.name === 'filterBy') {
				param = {
					...param,
					modelNumber: '',
					serialNumber: '',
				}
				error = {
					...error,
					modelNumberError: '',
					serialNumberError: '',
				};
				if(this.modelNumber)
					this.modelNumber.value = '';
				if(this.serialNumber)
					this.serialNumber.value = '';
			}else if(event.target.name == 'serialNumber'){
				const serialNumber = event.target.value.toUpperCase(); 
				event.target.value = serialNumber;
				param = {
					...param,
					serialNumber: serialNumber,
				}
			}
		}
		this.setState({
			[formName]: {
				param,
				error
			}
		});
	}

	handleSortBy(event) {
		let sortBy = event.target.value.split(',')[0],
			sortOrder = event.target.value.split(',')[1],
			{ requestReturnList } = this.state,
			isAnyDateFilter = sortBy.indexOf('Date') !== -1;
		var self = this;
		requestReturnList.responseObject = _.orderBy(requestReturnList.responseObject, (e) => {
			return !isAnyDateFilter?e.orderHeader[sortBy]:self.props.formatDate(e.orderHeader[sortBy], 'MM/DD/YY')
		}, [sortOrder]);
		this.setState({
			sortBy: event.target.value,
			requestReturnList,
		}, () => {
			// self.props.saveRequestReturnList(JSON.parse(JSON.stringify(requestReturnList)));
		});
	}

	handleResetForm(event, whichFilter) {
		const self = this;
		self.setState({
			filterListOfOrders: {
				param: {
					...self.state.filterListOfOrders.param,
					filterBy: '',
					filterString: ''
				},
				error: {
					...self.state.filterListOfOrders.error,
					filterByError: '',
					filterStringError: ''
				}
			},
			requestReturnList: null,
		});
	}

	handleFetchOrderDetails(orderHeader, wheretoRedirect, event) {
		event.preventDefault();
		const self = this;
		self.props.getOrderDetails('orderNumber='+orderHeader.orderNumber+'&requestType=getOrderDetails&accountNumber='+self.props.getSelectedAccountNumber(), (response) => {
			if(!response.status) {
				self.setState({
					errorMessage: response.responseMessage
				})
			} else {
				const { allSelectedAccountsAllPriceSources } = self.props.state.user;
				const billToLocationDetails = response.responseObject.billingAddress ? response.responseObject.billingAddress.locationId : null;
				let isValidBillTo = true;
				const saDetails = allSelectedAccountsAllPriceSources.find(item => item.AGREEMENT_NUMBER.toString() === orderHeader.salesAgreement.agreementNumber);
				if (billToLocationDetails && saDetails.BILL_TO_LOCATION && billToLocationDetails !== saDetails.BILL_TO_LOCATION) {
					isValidBillTo = false;
				}
				response.responseObject = {
					...response.responseObject,
					isValidBillTo
				};
				// exclude GEA Parts line type
				response.responseObject.items = response.responseObject.items.filter(item => item.lineType !== 'GEA Parts');
				// Save manage order list into store
				response.responseObject.items.forEach(itm => {
					itm.bkpOriginalSerialNumber = itm.serialNumber;
				});
				self.props.setRequestReturnDetails(response);
				self.props.saveRequestReturnList(self.state.requestReturnList);
				browserHistory.push('/' + wheretoRedirect);
			}
		});
	}

	handleProductNumberChange(itemIndex, productDetails) {
		const self = this;
		if(productDetails && productDetails.status) {
			self.setState({
				filterListOfOrders: {
					...self.state.filterListOfOrders,
					param: {
						...self.state.filterListOfOrders.param,
						modelNumber: productDetails.sku
					}
				},
				inValid: false,
			});
		}
	}

	handleChangeProductNumberTextBox(indx, productNumber, productListSuggestion, inValid) {
		const self = this;
		self.setState({
			inValid,
			filterListOfOrders: {
				param: {
					...self.state.filterListOfOrders.param,
					modelNumber: productNumber,
				},
				error: {
					...self.state.filterListOfOrders.error,
					modelNumberError: '',
				}
			},
		});
	}

	handleReturnLinesDetails(returnLines, orderHeader, event) {
		event && event.preventDefault();
		const self = this;
		let orderNum = orderHeader.orderNumber;
		self.props.savePreviousReturnAndCreditDetails({
			orderNum,
			returnLines
		});
		self.props.saveRequestReturnList(self.state.requestReturnList);
		browserHistory.push('/previousreturnandcredit');
	}

	handleContinue(orderHeader, attribute,fm_SERIAL_NUMBER, resultLineNumber, event) {
		event.preventDefault();
		const self = this;
		self.props.getOrderDetails('orderNumber='+orderHeader.orderNumber+'&requestType=getOrderDetails&accountNumber='+self.props.getSelectedAccountNumber(), (response) => {
			self.props.setRequestReturnDetails(response);
			self.props.saveRequestReturnList(self.state.requestReturnList);
			response.responseObject.items = response.responseObject && response.responseObject.items.filter(itm =>{return itm.serialNumber != "" && itm.internalItem == attribute})
				self.ifAllSelectedAccessories((accessories) => {
					if(accessories.length === response.responseObject.items.length) {
						self.handleDialog("RequestReturnOnlyAccessoriesSelectedOverlayDialog", true);
					} else {
						self.callBackContinue( response.responseObject, fm_SERIAL_NUMBER, resultLineNumber);
					}
				}, response.responseObject);
		});

	}
	ifAllSelectedAccessories(callback, obj) {
		const self = this;
		self.props.getItemTypeByOrderDetails(obj, resp => {
			if(!resp.status) {
				self.setState({
					errorMessage: resp.responseMessage
				})
			} else {
				self.props.saveRequestReturnPimData(resp.pimData);
				const orderDetails = resp.orderDetails;
				const accessories = orderDetails && orderDetails.items && orderDetails.items.filter(itm => itm.itemType === 'A');
				callback && callback(accessories);
			}
		});
	}

	callBackContinue(obj, fm_SERIAL_NUMBER, resultLineNumber) {
		const self = this;
		const items = [];
		obj.items.forEach(itm => {
			items.push({
				...itm,
				originalSerialNumbers: itm.serialNumber,
				serialNumber:fm_SERIAL_NUMBER,
				selected:(itm.lineNo == resultLineNumber[0] && itm.shipmentNumber == resultLineNumber[1])? true:false,
				returnQuantity:1,
			});
		});
		self.props.setRequestReturnDetails({
			responseObject: {
				...obj,
				items,
				originalOrderNumber: obj.orderNumber,
				shippingMethod: obj.deliveryMethod,
				deliveryInstructions: "",
				requestedDeliveryDate: ""
			}
		});
		browserHistory.push("/requestreturnstep2");
	}


    render() {
		const self = this;
		const {
			requestReturnList,
			inValid,
			filterListOfOrders: {
				param: {
					filterBy
				}
			}
		} = self.state;
		let showOlderThanInvoiceMessage = false;
		let showOlderThanInvoiceMessageForEmployee = false;
		let isOlderThanTwoYear = false;
		let isOlderThanYear = false;
		let serialNumberHyperLink = false;
		let isAlreadyRetrnQtyLessThenOrdered = true;
		const { CUSTOMERCLASSCODE} = self.props.state.user.accountDetail.responseObject !== null && self.props.state.user.accountDetail.responseObject !== 'undefined' ? self.props.state.user.accountDetail.responseObject[0]: '';
        return (
			<div>
		        <div className="push">
				<h1 className="pageTitle mx-3">Request Return</h1>
		        </div>
				<div className="push mx-3">
					<p className="push">To start a return, <b>select an order</b> from the list below associated with the product(s) and/or service(s) you need to return.<br /><a onClick={this.handleDialog.bind(this, "ReturnPolicyGuidelinesOverlayDialog", true)} href="">View Return Guidelines</a></p>
					<form className="returnProductsFilterForm" name="returnProductsFilterForm" id="returnProductsFilterForm" onSubmit={this.handleFilterListOfOrders.bind(this)}>
						<div className="filterBoxType2 particularOrderShadedBox">
						<h3>Filter the list of orders by using the search criteria below.</h3>
						<div className='filterBoxForLg'>
								<p>Filter by P.O. #, CSO (order number), Serial #, Invoice # or Order Reference #</p>
								<p>
								<select ref={(select) => this.filterBy = select} defaultValue={this.state.filterListOfOrders.param.filterBy} name="filterBy" onChange={this.updateParams.bind(this, 'filterListOfOrders')} className={"fullWidth p-2" + this.state.filterListOfOrders.error.filterByError}>
										<option value="">Select one...</option>
										<option value="poNumber">P.O. #</option>
										<option value="orderNumber">CSO (Order number)</option>
										<option value="serialNumber">Serial #</option>
										<option value="invoiceNumber">Invoice #</option>
										<option value="referenceNumber">Order Reference # (CTN #)</option>
									</select>
								</p>
								{this.state.filterListOfOrders.param.filterBy !== 'serialNumber' &&
									<p>
									<input ref={(input) => this.filterString = input} onChange={this.updateParams.bind(this, 'filterListOfOrders')} className={"fullWidth p-2 " + this.state.filterListOfOrders.error.filterStringError + (filterBy === 'poNumber' || filterBy === 'referenceNumber' ? ' text-transform-uppercase' : '')} type="text" name="filterString" disabled={this.state.filterListOfOrders.param.filterBy === ''} value={this.state.filterListOfOrders.param.filterString} />
									</p>}
								{this.state.filterListOfOrders.param.filterBy === 'serialNumber' &&
									<p className={this.state.filterListOfOrders.error.modelNumberError + ' auto-width-input'}>
										<AccountNumberAutoSuggests onChangeProductNumberTextBox={this.handleChangeProductNumberTextBox.bind(this)} updateQuickOrderState={this.handleProductNumberChange.bind(this)} size={8} placeHolder="Model #" />
										{inValid
											?<span className="red">Invalid product Number.</span>
											:null
										}
									</p>
								}
								{this.state.filterListOfOrders.param.filterBy === 'serialNumber' &&
									<p>
										<input placeholder="Serial # e.g., AB123456" 
										ref={(input) => this.serialNumber = input} 
										onChange={this.updateParams.bind(this, 'filterListOfOrders')} 
										className={"fullWidth p-2 " + this.state.filterListOfOrders.error.serialNumberError} 
										type="text" 
										name="serialNumber" 
										title='Serial numbers should have 2 letters(In UpperCase) and 6 numbers.'
										disabled={this.state.filterListOfOrders.param.filterBy !== 'serialNumber'} 
										value={this.state.filterListOfOrders.param.serialNumber} 
										maxLength={8}/>
									</p>}
									<p className='d-flex'>
                          			<input type="submit" defaultValue="Search" />
									&nbsp; &nbsp;
									<input type="reset" className="blue looksLikeALink" onClick={this.handleResetForm.bind(this, 'other')} value="Clear Search" />
								</p>
							</div>
							<div className="clear" />
						</div>
    				</form>
	          	</div>
			  	<p className="red bold">{this.state.errorMessage}</p>
				<p className="bold"><b>{this.state.filterConfirmationMessage}</b></p>
				{requestReturnList && requestReturnList.status && !this.state.filterConfirmationMessage &&
			         <div className="push d-none d-sm-block">
			          	<div className="captionAboveTable">
				            <div className="columns twoColumns">
				              	<div className="column">
				                	<div className="bold big">{requestReturnList.responseObject.length} Orders</div>
				              	</div>
				              	<div className="column textRight">
					                <form className="manageOrdersSortBy" name="manageOrdersSortBy" id="manageOrdersSortBy">
					                  	<label>
					                    	Sort by: &nbsp;
											<select onChange={this.handleSortBy.bind(this)} name="sortBy" defaultValue={this.state.sortBy}>
												<option value="orderNumber,asc">CSO (Order number)</option>
												<option value="orderDate,desc">Order Date</option>
												<option value="invoiceDate,desc">Invoice Date</option>
												<option value="ponumber,desc">P.O. #</option>
												<option value="createdBy,desc">Entered By</option>
											</select>
					                  	</label>
					                </form>
				              	</div>
				            </div>
			          	</div>
			          	<table className="dataTable returnProductsOrderListTable withAlternatingTbodyElements">
							<thead>
								<tr>
									<th className="orderNumber">CSO (Order number)</th>
									<th className="orderDate">Order Date</th>
									<th className="invoiceNumber">Invoice #</th>
									<th className="invoiceDate">Invoice Date</th>
									<th className="poNumber">P.O. #</th>
									<th className="product">Product</th>
									<th className="serial">Serial#</th>
									<th>Previous Returns/<br />Credits</th>
								</tr>
							</thead>
			            	<tbody>
								{requestReturnList.responseObject.length === 0
									?<tr>
										<td colSpan={6}>No orders found meeting the specified criteria; please try your search again.</td>
									</tr>
									:null
								}
								{requestReturnList.responseObject.length > 0 && requestReturnList.responseObject.map((item, index) => {
									let { orderHeader, orderDetail } = item,
										{ attribute } = orderHeader.attributes;
									attribute = attribute?_.find(attribute, ['name', 'Attribute2']):null;
									const {
										invoiceNumber,
										invoiceDate,
									} = self.processInvoiceNumberDate(orderHeader);
									let invoice_NUMBER , invoice_DATE, attribute1, fm_SERIAL_NUMBER, line_NUMBER ='';
									self.props.state.order.serialData && self.props.state.order.serialData.length > 0 && self.props.state.order.serialData.filter((itm)=>{
										if(itm.order_NUMBER == orderHeader.orderNumber){
											invoice_NUMBER =itm.invoice_NUMBER;
											invoice_DATE =  itm.invoice_DATE; 
											attribute1 = itm.attribute1;
											fm_SERIAL_NUMBER = itm.fm_SERIAL_NUMBER;
											line_NUMBER = itm.line_NUMBER;
										}
									})
									let returnLines ='';
									let hyperlinkSerial = false;
									let resultLineNumber = line_NUMBER.split('.');
									orderDetail && orderDetail.orderLine && orderDetail.orderLine.map(itm => {
										if(itm.item === attribute1 && itm.lineNum == resultLineNumber[0] && itm.shipmentNum == resultLineNumber[1] && itm.returnDetails && itm.returnDetails.returnLine && itm.returnDetails.returnLine.length >0){
											returnLines = itm.returnDetails.returnLine.filter(returnItems =>{
												let orderedQuantity =parseInt(itm.orderedQty, 10);
												let calculatedReturnQuantity =orderedQuantity - returnItems.authorizedQty;
												if(calculatedReturnQuantity == 0){
													hyperlinkSerial = true;
												}
												if(calculatedReturnQuantity > 0){
													hyperlinkSerial = false;
												}
												return returnItems.lineType.toLowerCase() !== 'bill only line'
										});
										let totalAlreadyRetrnedQty = 0 
											if(returnLines) {
												totalAlreadyRetrnedQty = _.sumBy(returnLines,'authorizedQty');
												isAlreadyRetrnQtyLessThenOrdered = totalAlreadyRetrnedQty < parseInt(itm.orderedQty, 10) ? true : false;
											}
									}}
									);
									const relationShipTypes =  self.props.state.user.relationShipPartyList && self.props.state.user.relationShipPartyList.responseObject && self.props.state.user.relationShipPartyList.responseObject.filter(party => party.RELATIONSHIP_STATUS === 'A').map(item => item.RELATIONSHIP_TYPE);
									const invoice = self.props.state.user.allTcaList && self.props.state.user.allTcaList.responseObject && self.props.state.user.allTcaList.responseObject.filter(item => relationShipTypes.includes(item.tcaRelationshipName));
									const defaultInvoice = self.props.state.user.allTcaList && self.props.state.user.allTcaList.responseObject && self.props.state.user.allTcaList.responseObject.filter(item => item.tcaRelationshipName === 'Default');
									const invoiceAge =invoice && invoice.length > 0 ? invoice[0].invoiceAge : defaultInvoice[0].invoiceAge;
									let invoiceDateFinal=this.props.pickTheDateFromString(this.state.filterListOfOrders.param.filterBy == 'serialNumber'?invoice_DATE:invoiceDate)
									isOlderThanTwoYear = moment(invoiceDateFinal).isBefore(moment().subtract(2, 'years'));
									isOlderThanYear = moment(invoiceDateFinal).isBefore(moment().subtract(1, 'years'));
									if(invoiceDateFinal && moment(invoiceDateFinal).isBefore(moment().subtract(invoiceAge, 'days'), 'day')  && self.props.state.user.userDetails.typeOfUser == "customer") {
										showOlderThanInvoiceMessage= true;
									}
									if(invoiceDateFinal && moment(invoiceDateFinal).isBefore(moment().subtract(invoiceAge, 'days'), 'day')  && self.props.state.user.userDetails.typeOfUser == "employee") {
										showOlderThanInvoiceMessageForEmployee= true;
									}
									if(this.state.filterListOfOrders.param.filterBy === 'serialNumber' && self.props.state.order.serialData && self.props.state.order.serialData.length > 0 && self.props.state.order.serialData.filter(item => item.line_TYPE === "Return Line").length >0) {
										serialNumberHyperLink= true;
									}
									return <tr key={index}>
										  {(showOlderThanInvoiceMessage || serialNumberHyperLink || isOlderThanTwoYear || (isOlderThanYear && CUSTOMERCLASSCODE === "AS-IS"))  ?<td className="orderNumber">{orderHeader.orderNumber}</td>:
										 <td className="orderNumber"><a className="bold" href="" onClick={this.handleFetchOrderDetails.bind(this, orderHeader, 'requestreturnstep1')}>{orderHeader.orderNumber}</a></td>}
										<td className="orderDate">{this.props.formatDate(orderHeader.orderDate, 'MM/DD/YY')}</td>
										<td className="invoiceNumber">{this.state.filterListOfOrders.param.filterBy == 'serialNumber'?invoice_NUMBER:invoiceNumber}</td>
										<td className="invoiceDate">{invoiceDateFinal}</td>
										<td className="poNumber">{orderHeader.ponumber}</td>
										<td className="product">{this.state.filterListOfOrders.param.filterBy == 'serialNumber'?attribute1:""}</td>
										{(!isAlreadyRetrnQtyLessThenOrdered || showOlderThanInvoiceMessage || serialNumberHyperLink || hyperlinkSerial || isOlderThanTwoYear ||(isOlderThanYear && CUSTOMERCLASSCODE === "AS-IS")) ?<td className="serial">{this.state.filterListOfOrders.param.filterBy == 'serialNumber'?fm_SERIAL_NUMBER:""}</td>
										:<td className="serial"><a className="bold" href="" onClick={this.handleContinue.bind(this, orderHeader, attribute1, fm_SERIAL_NUMBER, resultLineNumber)}>{this.state.filterListOfOrders.param.filterBy == 'serialNumber'?fm_SERIAL_NUMBER:""}</a></td>}
										<td>{this.state.filterListOfOrders.param.filterBy === 'serialNumber' && returnLines && returnLines.length > 0 && <a href="" onClick={this.handleReturnLinesDetails.bind(this, returnLines, orderHeader)}>Click here</a>}</td>
									</tr>
								})}
			            	</tbody>
			          	</table>
						  {(isOlderThanYear && CUSTOMERCLASSCODE === "AS-IS") ? <p className="bold red">{this.state.olderThanYearMessage}</p> :(showOlderThanInvoiceMessage || showOlderThanInvoiceMessageForEmployee) && <p className="bold red">{this.state.olderThanInvoiceAgeMessage}</p>}
						  {isOlderThanTwoYear && <p className="bold red">{this.state.olderThanTwoYearMessage}</p> }
						  {this.state.filterListOfOrders.param.filterBy === 'serialNumber' && self.props.state.order.serialData && self.props.state.order.serialData.length > 0 && self.props.state.order.serialData.filter(item => item.line_TYPE === "Return Line").length>0? <p className="bold red">{`This serial number has already been returned:`}</p>:''}
						  {this.state.filterListOfOrders.param.filterBy === 'serialNumber' && self.props.state.order.serialData && self.props.state.order.serialData.length > 0 && self.props.state.order.serialData.filter(item => item.line_TYPE === "Return Line").length>0? <table className="dataTable returnProductsOrderListTable withAlternatingTbodyElements">
							<thead>
								<tr>
									<th className="orderNumber">CSO (Order number)</th>
									<th className="invoiceNumber">Invoice #</th>
									<th className="invoiceDate">Invoice Date</th>
									<th className="product">Product</th>
									<th className="serial">Serial#</th>
								</tr>
							</thead>
			            	<tbody>
							{this.state.filterListOfOrders.param.filterBy === 'serialNumber' && self.props.state.order.serialData && self.props.state.order.serialData.length > 0 && self.props.state.order.serialData.filter(item => item.line_TYPE === "Return Line").map((itm, index)=>{
										return <tr key={index}>
										<td className="orderNumber">{itm.order_NUMBER}</td>
										<td className="invoiceNumber">{itm.invoice_NUMBER}</td>
										<td className="invoiceDate">{moment(itm.invoice_DATE).format('MM/DD/YYYY')}</td>
										<td className="product">{itm.attribute1}</td>
										<td className="serial">{itm.fm_SERIAL_NUMBER}</td>
									</tr>
									})
								 }
			            	</tbody>
						</table>:''}
			        </div>
				}
				{requestReturnList && requestReturnList.status && !this.state.filterConfirmationMessage &&
			         <div className="push d-block d-sm-none m-3">
			          	<div className="captionAboveTableMobile">
				              	<div className="column">
				                	<div className="bold big">{requestReturnList.responseObject.length} Orders</div>
				              	</div>
			          	</div>
						  {requestReturnList.responseObject.length > 0 && requestReturnList.responseObject.map((item, index) => {
									let { orderHeader, orderDetail } = item,
										{ attribute } = orderHeader.attributes;
									attribute = attribute?_.find(attribute, ['name', 'Attribute2']):null;
									const {
										invoiceNumber,
										invoiceDate,
									} = self.processInvoiceNumberDate(orderHeader);
									let invoice_NUMBER , invoice_DATE, attribute1, fm_SERIAL_NUMBER, line_NUMBER ='';
									self.props.state.order.serialData && self.props.state.order.serialData.length > 0 && self.props.state.order.serialData.filter((itm)=>{
										if(itm.order_NUMBER == orderHeader.orderNumber){
											invoice_NUMBER =itm.invoice_NUMBER;
											invoice_DATE =  itm.invoice_DATE; 
											attribute1 = itm.attribute1;
											fm_SERIAL_NUMBER = itm.fm_SERIAL_NUMBER;
											line_NUMBER = itm.line_NUMBER;
										}
									})
									let returnLines ='';
									let hyperlinkSerial = false;
									let resultLineNumber = line_NUMBER.split('.');
									orderDetail && orderDetail.orderLine && orderDetail.orderLine.map(itm => {
										if(itm.item === attribute1 && itm.lineNum == resultLineNumber[0] && itm.shipmentNum == resultLineNumber[1] && itm.returnDetails && itm.returnDetails.returnLine && itm.returnDetails.returnLine.length >0){
											returnLines = itm.returnDetails.returnLine.filter(returnItems =>{
												let orderedQuantity =parseInt(itm.orderedQty, 10);
												let calculatedReturnQuantity =orderedQuantity - returnItems.authorizedQty;
												if(calculatedReturnQuantity == 0){
													hyperlinkSerial = true;
												}
												if(calculatedReturnQuantity > 0){
													hyperlinkSerial = false;
												}
												return returnItems.lineType.toLowerCase() !== 'bill only line'
										});
										let totalAlreadyRetrnedQty = 0 
											if(returnLines) {
												totalAlreadyRetrnedQty = _.sumBy(returnLines,'authorizedQty');
												isAlreadyRetrnQtyLessThenOrdered = totalAlreadyRetrnedQty < parseInt(itm.orderedQty, 10) ? true : false;
											} 
									}}
									);
									const relationShipTypes =  self.props.state.user.relationShipPartyList && self.props.state.user.relationShipPartyList.responseObject && self.props.state.user.relationShipPartyList.responseObject.filter(party => party.RELATIONSHIP_STATUS === 'A').map(item => item.RELATIONSHIP_TYPE);
									const invoice = self.props.state.user.allTcaList && self.props.state.user.allTcaList.responseObject && self.props.state.user.allTcaList.responseObject.filter(item => relationShipTypes.includes(item.tcaRelationshipName));
									const defaultInvoice = self.props.state.user.allTcaList && self.props.state.user.allTcaList.responseObject && self.props.state.user.allTcaList.responseObject.filter(item => item.tcaRelationshipName === 'Default');
									const invoiceAge =invoice && invoice.length > 0 ? invoice[0].invoiceAge : defaultInvoice[0].invoiceAge;
									let invoiceDateFinal=this.props.pickTheDateFromString(this.state.filterListOfOrders.param.filterBy == 'serialNumber'?invoice_DATE:invoiceDate)
									if(invoiceDateFinal && moment(invoiceDateFinal).isBefore(moment().subtract(invoiceAge, 'days'), 'day')  && self.props.state.user.userDetails.typeOfUser == "customer") {
										showOlderThanInvoiceMessage= true;
									}
									if(invoiceDateFinal && moment(invoiceDateFinal).isBefore(moment().subtract(invoiceAge, 'days'), 'day')  && self.props.state.user.userDetails.typeOfUser == "employee") {
										showOlderThanInvoiceMessageForEmployee= true;
									}
									if(this.state.filterListOfOrders.param.filterBy === 'serialNumber' && self.props.state.order.serialData && self.props.state.order.serialData.length > 0 && self.props.state.order.serialData.filter(item => item.line_TYPE === "Return Line").length >0) {
										serialNumberHyperLink= true;
									}
									return <div className="accordion accordion-borderless" id={`accordionRequestReturn1${index}`}  key={index}>
									<div>
										<h2 className="accordion-header" id={`flush-requestReturn1${index}`}>
										<button className="accordion-button mobileAccButton" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseOneRR${index}`} aria-expanded="true" aria-controls={`flush-collapseOneRR${index}`}>
											{`ORDER `} {(showOlderThanInvoiceMessage || serialNumberHyperLink) ?<td className="orderNumber" style={{paddingLeft:"1rem"}}>{orderHeader.orderNumber}</td>:
										 <td className="orderNumber"><a className="bold" style={{paddingLeft:"1rem"}} href="" onClick={this.handleFetchOrderDetails.bind(this, orderHeader, 'requestreturnstep1')}>{orderHeader.orderNumber}</a></td>}
										</button>
										</h2>
										<div id={`flush-collapseOneRR${index}`} className="accordion-collapse collapse show" aria-labelledby={`flush-requestReturn1${index}`} data-bs-parent={`#accordionRequestReturn1${index}`}>
												<table className='orderTable'>
													<tbody>
														<tr className='border-bottom'>
															<td className='p-3 fw-bold'>ORDER DATE</td>
															<td className="orderDate">{this.props.formatDate(orderHeader.orderDate, 'MM/DD/YY')}</td>
														</tr>
														<tr className='border-bottom'>
															<td className='p-3 fw-bold'>INVOICE #</td>
															<td className="invoiceNumber">{this.state.filterListOfOrders.param.filterBy == 'serialNumber'?invoice_NUMBER:invoiceNumber}</td>
														</tr>
														<tr className='border-bottom'>
															<td className='p-3 fw-bold'>INVOICE DATE</td>
															<td className="invoiceDate">{invoiceDateFinal}</td>
														</tr>
														<tr className='border-bottom'>
															<td className='p-3 fw-bold'>PO #</td>
															<td className="poNumber">{orderHeader.ponumber}</td>
														</tr>
														<tr className='border-bottom'>
															<td className='p-3 fw-bold'>PRODUCT</td>
															<td className="product">{this.state.filterListOfOrders.param.filterBy == 'serialNumber'?attribute1:""}</td>
														</tr>
														<tr>
															<td className='p-3 fw-bold'>SERIAL #</td>
															{(!isAlreadyRetrnQtyLessThenOrdered || showOlderThanInvoiceMessage || serialNumberHyperLink || hyperlinkSerial) ?<td className="serial">{this.state.filterListOfOrders.param.filterBy == 'serialNumber'?fm_SERIAL_NUMBER:""}</td>
															:<td className="serial"><a className="bold" href="" onClick={this.handleContinue.bind(this, orderHeader, attribute1, fm_SERIAL_NUMBER, resultLineNumber)}>{this.state.filterListOfOrders.param.filterBy == 'serialNumber'?fm_SERIAL_NUMBER:""}</a></td>}
														</tr>
														{this.state.filterListOfOrders.param.filterBy === 'serialNumber' && returnLines && returnLines.length > 0 && <tr>
															<td className='p-3'>{' '}</td>
															<td> <a href="" onClick={this.handleReturnLinesDetails.bind(this, returnLines, orderHeader)}>PreviousReturn/Credits</a></td>
														</tr>}
													</tbody>
												</table>
										</div>
									</div>
									</div>
								})}
						  {(showOlderThanInvoiceMessage || showOlderThanInvoiceMessageForEmployee) && <p className="bold red">{this.state.olderThanInvoiceAgeMessage}</p>}
						  {this.state.filterListOfOrders.param.filterBy === 'serialNumber' && self.props.state.order.serialData && self.props.state.order.serialData.length > 0 && self.props.state.order.serialData.filter(item => item.line_TYPE === "Return Line").length>0? <p className="bold red">{`This serial number has already been returned:`}</p>:''}
						  {this.state.filterListOfOrders.param.filterBy === 'serialNumber' && self.props.state.order.serialData && self.props.state.order.serialData.length > 0 && self.props.state.order.serialData.filter(item => item.line_TYPE === "Return Line").length>0? 
							<div>
								{self.props.state.order.serialData && self.props.state.order.serialData.length > 0 && self.props.state.order.serialData.filter(item => item.line_TYPE === "Return Line").map((itm, index)=>{
										return <div className="accordion accordion-borderless" id={`accordionRequestReturn2${index}`}  key={index}>
										<div>
											<h2 className="accordion-header" id={`flush-RequestReturn2${index}`}>
											<button className="accordion-button mobileAccButton" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseOneRequestReturn2${index}`} aria-expanded="true" aria-controls={`flush-collapseOneRequestReturn2${index}`}>
												{`RETURN ORDER `} {<div style={{paddingLeft:"1rem"}}>{itm.order_NUMBER}</div>}
											</button>
											</h2>
											<div id={`flush-collapseOneRequestReturn2${index}`} className="accordion-collapse collapse show" 
											aria-labelledby={`flush-requestReturn2${index}`} data-bs-parent={`#accordionRequestReturn2${index}`}>
													<table className='orderTable'>
														<tbody>
															<tr className='border-bottom'>
																<td className='p-3 fw-bold'>INVOICE #</td>
																<td className="invoiceNumber">{itm.invoice_NUMBER}</td>
															</tr>
															<tr className='border-bottom'>
																<td className='p-3 fw-bold'>INVOICE DATE</td>
																<td className="invoiceDate">{moment(itm.invoice_DATE).format('MM/DD/YYYY')}</td>
															</tr>
															<tr className='border-bottom'>
																<td className='p-3 fw-bold'>PRODUCT</td>
																<td className="product">{itm.attribute1}</td>
															</tr>
															<tr className='border-bottom'>
																<td className='p-3 fw-bold'>SERIAL #</td>
																<td className="serial">{itm.fm_SERIAL_NUMBER}</td>
															</tr>
														</tbody>
													</table>
											</div>
										</div>
										</div>
									})
								 }
			            	</div>:''}
			        </div>
				}
				{self.state.showSerialErrorMessage && self.state.showRequestReturnFileWarningDialog && <RequestReturnFileWarningDialog content ={`Serial number should have 2 letters and 6 numbers.`} handleDialog={this.handleDialog.bind(this)} showDialog={true}/>}
				{this.state.showSelectProductsToReturnOverlayDialog?<SelectProductsToReturnOverlayDialog handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showReturnPolicyGuidelinesOverlayDialog?<ReturnPolicyGuidelinesOverlayDialog handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
	      	</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getOrderList: (queryStringParams, callback) => dispatch(getOrderList(queryStringParams, callback)),
	saveRequestReturnList: (requestReturnList) => dispatch(saveRequestReturnList(requestReturnList)),
	setRequestReturnDetails: (data) => dispatch(setRequestReturnDetails(data)),
	saveSerialData: (data) => dispatch(saveSerialData(data)),
	updateRequestReturnParams: (data) => dispatch(updateRequestReturnParams(data)),
	ajaxRequestInitiated: (data) => dispatch(ajaxRequestInitiated(data)),
	ajaxRequestCompleted: (data) => dispatch(ajaxRequestCompleted(data)),
	getOrderDetails: (queryStringParams, callback) => dispatch(getOrderDetails(queryStringParams, callback)),
	savePreviousReturnAndCreditDetails: (data) => dispatch(savePreviousReturnAndCreditDetails(data)),
	saveRequestReturnPimData: (requestReturnPimdata) => dispatch(saveRequestReturnPimData(requestReturnPimdata)),
});

RequestReturn = connect(mapStateToProps, mapDispatchToProps)(RequestReturn);
export default RequestReturn;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/requestReturn.js